"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
require("./NodeWarning.scss");
var NodeWarning = function (_a) {
    var text = _a.text, position = _a.position, active = _a.active;
    var warningRef = react_1["default"].useRef(null);
    var _b = react_1["default"].useState(0), offsetTop = _b[0], setOffsetTop = _b[1];
    react_1["default"].useEffect(function () {
        var _a;
        if (active) {
            setOffsetTop(((_a = warningRef === null || warningRef === void 0 ? void 0 : warningRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) - 35);
        }
    }, [active]);
    return (react_1["default"].createElement("div", { className: "nodeWarning " + (active ? 'active' : ''), style: { left: position.left - 75, top: position.top - offsetTop }, ref: warningRef },
        react_1["default"].createElement(box_1["default"], { borderRadius: "sm", backgroundColor: "grey.deep", padding: 14 },
            react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.soft" }, text))));
};
exports["default"] = NodeWarning;
